import { useEffect, useState } from 'react';
import axios from 'axios';
import Statistic from './index';
import { useSelector } from "react-redux";
import { API_URL } from '../../config/constants';

function StatisticGuard() {
    const login = useSelector((state) => state.session?.login);
    const [allow, setAllow] = useState(null);

    useEffect(() => {
        if (!login) {
            setAllow(false);
            return;
        }
        let cancelled = false;
        (async () => {
            try {
                const { data } = await axios.post(
                    `${API_URL}/monitoring-manage/getSessionPrivilege`,
                    {},
                    { withCredentials: true }
                );
                if (cancelled) return;
                const read = data?.privilege?.StatisticView?.read;
                console.log("read", read)
                setAllow(read === true);
            } catch {
                if (!cancelled) setAllow(false);
            }
        })();
        return () => { cancelled = true; };
    }, [login]);

    if (allow !== true) {
        return null;
    }

    return <Statistic />;
}

export default StatisticGuard;
